export default __webpack_public_path__ + "static/media/dispute_gray.9f1422b3.svg";